import { useState } from "react";

import { SearchSpacer } from "src/components/common/common";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import { usePRD2050_R01Store } from "./Store_PRD2050_R01";

/** 사업장, 생산일자, 작업공정, 작업팀 검색조건을 Store와 연결한다. */
export const SearchSection_PRD2050_R01 = () => {
  const { PRD2050_R01Filter, setPRD2050_R01Filter } = usePRD2050_R01Store();
  const { compCdList, workPlaceList, jobTeamList } = useCommonCodeStore();
  const [pickerVisible, setPickerVisible] = useState(false);
  const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

  return (
    <SearchSectionDoubleForm>
      <SearchDropDownForm
        label="사업장"
        value={PRD2050_R01Filter.compCd}
        onChangeItem={(item) =>
          setPRD2050_R01Filter({ compCd: item?.compCd || "" })
        }
        optionList={compCdList}
      />
      <SearchDateRangeForm
        label="생산일자"
        visible={pickerVisible}
        setVisible={setPickerVisible}
        dateRange={PRD2050_R01Filter.dateRange}
        setDateRange={(dateRange) => setPRD2050_R01Filter({ dateRange })}
        pickerPosition={pickerPosition}
        setPickerPosition={setPickerPosition}
      />
      <SearchDropDownForm
        label="작업공정"
        value={PRD2050_R01Filter.workplaceCd}
        onChangeItem={(item) =>
          setPRD2050_R01Filter({ workplaceCd: item?.workplaceCd || "" })
        }
        optionList={workPlaceList.filter(
          (item) => item.compCd === PRD2050_R01Filter.compCd,
        )}
        editable={PRD2050_R01Filter.compCd !== ""}
      />
      <SearchDropDownForm
        label="작업팀"
        value={PRD2050_R01Filter.jobTeam}
        onChangeItem={(item) =>
          setPRD2050_R01Filter({ jobTeam: item?.minorCd || "" })
        }
        optionList={jobTeamList}
      />
    </SearchSectionDoubleForm>
  );
};
